import React from 'react';
import './Viewers.scss';

function parseNum (num) {
    num = num || 0;

    if( num > 1e6){
        return (num/1e4).toFixed(0)+ '万';
    }

    if( num > 1e4){
        return (num/1e4).toFixed(1)+ '万';
    }

    return num;

};

export default class Viewers extends React.Component{
    render() {
        const number = parseNum( this.props.number );
        return (
            <div className="m-viewers"><i className="i-viewer"></i>{ number }</div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/common/components/viewers/Viewers.jsx